<template>
    <div class="uik-filters-container">
        <div class="uik-filters-container__wrapper">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikFiltersContainer"
}
</script>

<style lang="scss">
.uik-filters-container {
    border-bottom: 1px solid #{$borderColor};
    .uik-filters-container__wrapper {
        max-width: 1450px;
        margin: 0 auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        &::-webkit-scrollbar-track {
            display: initial;
        }
        &::-webkit-scrollbar {
            height: 5px;
            display: initial;
        }
    }
    .divider {
        width: 2px;
        height: 20px;
        margin: 0 13px;
        margin-bottom: 4px;
        position: relative;
        background-color: transparent;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        &:before, &:after {
            content: "";
            height: 2px;
            width: 2px;
            position: absolute;
            background-color: $textLight;
            border-radius: 50%;
        }
        &:before {
            transform: translateY(-2px);
        }
        &:after {
            transform: translateY(2px);
        }
    }
}
</style>
